<template>

  <div class="active-basic">
    <div class="common-form">基本信息</div>

    
    <el-form-item label="房源图片:" prop="imgUrl">
      <div class="draggable-list">
        <draggable class="wrapper" v-model="form.imgUrl">
          <transition-group>
            <div v-for="(item, index) in form.imgUrl" :key="item.file_path">
              <div class="item">
                <img v-img-url="item.file_path" alt="file_path"/>
                <a href="javascript:void(0);" class="delete-btn" @click.stop="deleteImg(index)"><i class="el-icon-close"></i></a>
              </div>
            </div>
          </transition-group>
        </draggable>
        <div class="item img-select" @click="openProductUpload">
          <i class="el-icon-plus"></i>
        </div>
      </div>
      <p class="ml10 gray">提示：图片尺寸建议750x310</p>
    </el-form-item>

    <el-form-item label="视频" prop="video">
        <el-input type="text" v-model="form.video" placeholder="请选择视频" class="max-w460">
          <template slot="append">
            <el-button icon="el-icon-picture-outline" @click="openVideoUpload">选择视频
            </el-button>
          </template>
        </el-input>
        <!--上传视频组件-->
        <Upload v-if="isVideoUpload" :isupload="isVideoUpload" type="video" @returnImgs="returnVideosFunc">上传视频</Upload>
      </el-form-item>


    
    <el-form-item label="房源标题" prop="title" :rules="[{ required: true, message: '请输入房源标题' }]">
      <el-input v-model="form.title" placeholder="请输入房源标题" class="max-w460"></el-input>
    </el-form-item>

    <el-form-item label="联系人" prop="title" :rules="[{ required: true, message: '请输入联系人' }]">
      <el-input v-model="form.setting.name" placeholder="请输入联系人" class="max-w460"></el-input>
    </el-form-item>

    <el-form-item label="联系方式" prop="title" :rules="[{ required: true, message: '请输入联系方式' }]">
      <el-input v-model="form.setting.phone" placeholder="请输入联系方式" class="max-w460"></el-input>
    </el-form-item>

    <el-form-item label="标签" prop="setting" >
        <div>
             <el-button icon="el-icon-plus" @click.stop="addLabel">添加标签</el-button>
           </div>

           <table border cellspacing="0" class="mt10" style="border:1px solid #ECEFF7">
             <tr  style="border:1px solid #ECEFF7">
               <th class="w150" style="width: 100px;border:1px solid #ECEFF7">编号</th>
               <th class="w150" style="width: 100px;border:1px solid #ECEFF7">名称</th>
             </tr>
             <tr v-for="(item,index) in form.label" style="border:1px solid #ECEFF7">
               <td class="tc" style="border:1px solid #ECEFF7">{{ item.index }} </td>
               <td class="tc" style="border:1px solid #ECEFF7">
                  <el-input style="border:none;" v-model="item.name" placeholder="请输入名称"></el-input>
               </td>
  
               <td class="tc" style="width: 100px;border:1px solid #ECEFF7">
                <a @click="delLabel(item.id,index)"> 删除</a>
              </td>
             </tr>
           </table>
    </el-form-item>

    
   
    <el-form-item label="分类" prop="setting" >
        <div>
             <el-button icon="el-icon-plus" @click.stop="addCate">添加分类</el-button>
           </div>

           <table border cellspacing="0" class="mt10" style="border:1px solid #ECEFF7">
             <tr  style="border:1px solid #ECEFF7">
               <th class="w150" style="width: 100px;border:1px solid #ECEFF7">编号</th>
               <th class="w150" style="width: 100px;border:1px solid #ECEFF7">分类</th>
               <th class="w150" style="width: 100px;border:1px solid #ECEFF7">操作</th>
             </tr>
             <tr v-for="(item,index) in form.categorya" style="border:1px solid #ECEFF7">
               <td class="tc" style="border:1px solid #ECEFF7">{{ index+1 }} </td>
               <td class="tc" style="border:1px solid #ECEFF7">{{ item.name }} </td>
               <td class="tc" style="border:1px solid #ECEFF7">
                <div @click="chooseCategory(index)">选择分类</div>
              
               </td>
  
               <td class="tc" style="width: 100px;border:1px solid #ECEFF7">
                <a @click="delCate(item.id,index)"> 删除</a>
              </td>
             </tr>
           </table>
           <Categoryas :isproduct="iscategorya" :index="cindex" :excludeIds="excludeIds" 
                :islist="false" @closeDialog="closeDialogFunc"></Categoryas>
    </el-form-item>




  

    <el-form-item label="价格" prop="price" >
      <el-input type="text"  v-model="form.price" placeholder="请输入房源价格" class="max-w460"></el-input>
    </el-form-item>

    <el-form-item label="地址" prop="address" >
      <el-input type="text"  v-model="form.address" placeholder="请输入房源地址" class="max-w460"></el-input>
    </el-form-item>

    <el-form-item label="使用面积" prop="house_area" >
      <el-input type="text"  v-model="form.setting.house_area" placeholder="请输入使用面积" class="max-w460"></el-input>
    </el-form-item>

    <el-form-item label="户型" prop="hux" >
      <el-input type="text"  v-model="form.setting.hux" placeholder="请输入户型" class="max-w460"></el-input>
    </el-form-item>

    <el-form-item label="院子面积" prop="yzarea" >
      <el-input type="text"  v-model="form.setting.yzarea" placeholder="请输入院子面积" class="max-w460"></el-input>
    </el-form-item>

    <el-form-item label="装修" prop="diy" >
      <el-input type="text"  v-model="form.setting.diy" placeholder="请输入装修情况" class="max-w460"></el-input>
    </el-form-item>

    <el-form-item label="使用年限" prop="diy" >
      <el-input type="text"  v-model="form.setting.useYear" placeholder="请输入使用年限" class="max-w460"></el-input>
    </el-form-item>


<!-- 
    <el-form-item label="涨跌金额" prop="diy" >
      <el-input type="text"  v-model="form.ss_price" placeholder="请输入涨跌金额" class="max-w460"></el-input>
    </el-form-item>

    <el-form-item label="涨跌情况">
      <template >
        <el-radio-group v-model="form.ss">
          <el-radio :label="0">上涨</el-radio>
          <el-radio :label="1">下跌</el-radio>
        
        </el-radio-group>
      </template>

    </el-form-item> -->

    <el-form-item label="编号" prop="diy" >
      <el-input type="text"  v-model="form.numb" placeholder="请输入编号" class="max-w460"></el-input>
    </el-form-item>

    <el-form-item label="备注" prop="diy" >
      <el-input type="textarea"  v-model="form.note" placeholder="请输入备注" class="max-w460"></el-input>
    </el-form-item>



    <el-form-item label="广告图" prop="setting" >
        <div>
             <el-button icon="el-icon-plus" @click.stop="addBan">添加广告图</el-button>
           </div>

           <table border cellspacing="0" class="mt10" style="border:1px solid #ECEFF7">
             <tr  style="border:1px solid #ECEFF7">
              <th class="w150" style="width: 200px;border:1px solid #ECEFF7">图片</th>
               <th class="w150" style="width: 300px;border:1px solid #ECEFF7">跳转链接</th>
               <th class="w150" style="width: 100px;border:1px solid #ECEFF7">操作</th>
             </tr>
             <tr v-for="(item,index) in form.ban" style="border:1px solid #ECEFF7">

               
              <td>
                <div v-if="item.file_path" class="default-image-box" @click="isAboutLogoUpload = true">
                <div class="image-box">
                  <img :src="item.file_path" 
                  style="width: 200px;height: 100px;"
                  alt="product_default_image">
     
                </div>
              </div>
              <div v-else>
                <div class="img-select" @click="selectImage(index)"><i class="el-icon-plus"></i></div>
              </div>



              </td>
              
              <td class="tc" style="border:1px solid #ECEFF7">
      
                <el-input class="max-w460" placeholder="点击选择你要链接的位置" v-if="item.link" v-model="'链接到' + item.link.type + ' ' + item.link.name" :disabled="true"></el-input>
                <el-input class="max-w460" placeholder="点击选择你要链接的位置" v-if="!item.link" :disabled="true"></el-input>
                <el-button icon="el-icon-link" @click="changeLink(index)">选择链接</el-button>
               </td>
  
               <td class="tc" style="width: 100px;border:1px solid #ECEFF7">
                <a @click="delBan(index)"> 删除</a>
              </td>
             </tr>
           </table>
        
    </el-form-item>


    <el-form-item label="房源图文">
      <div class="edit_container" >
        <Uediter :id="ue1"  :text1="form.content" :config="ueditor.config" ref="ue1" @contentChange="contentChangeFunc"></Uediter>
      </div>
    </el-form-item>

     <!--上传图片组件-->
     <Upload v-if="isupload" :isupload="isupload" @returnImgs="returnImgsFunc">上传图片</Upload>


    <el-form-item label="是否免费">
      <template >
        <el-radio-group v-model="form.is_free">
          <el-radio :label="0">免费</el-radio>
          <el-radio :label="1">付费(VIP可查看联系方式)</el-radio>
        </el-radio-group>
      </template>

    </el-form-item>

    <el-form-item label="是否推荐">
      <template >
        <el-radio-group v-model="form.is_commond">
          <el-radio :label="1">推荐</el-radio>
          <el-radio :label="0">不推荐</el-radio>
        
        </el-radio-group>
      </template>

    </el-form-item>

    <Upload v-if="isProductUpload" :config="{ total: 9 }" :isupload="isProductUpload" @returnImgs="returnProductImgsFunc">上传图片
    </Upload>

    <Upload v-if="isAboutLogoUpload" :config="{ total: 9 }" :isupload="isAboutLogoUpload" @returnImgs="returnLogoImgsFunc">上传图片</Upload>
 
    <Setlink
      v-if="is_linkset"
      :is_linkset="is_linkset"
      @closeDialog="closeLinkset"
      >选择链接</Setlink>
  </div>
</template>

<script>
import Setlink from "@/components/setlink/Setlink";
import Uediter from '@/components/UE1.vue';
import Upload from '@/components/file/Upload';
import Categoryas from "@/components/categorya/index.vue";
import draggable from 'vuedraggable';
export default {
  components: {
    Uediter,
    Categoryas,
    Upload,
    draggable,
    Setlink
  },
  data() {
    /*验证图片是否上传*/
    const validatorImages = (rule, value, callback) => {
      if (value < 1) {
        return callback(new Error('请上传房源图'));
      } else {
        callback();
      }
    };
    return {
      /*如果没有后面的-8.64e7就是不可以选择今天的*/
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() < Date.now() - 8.64e7;
        }
      },
      isupload:false,
      isAboutLogoUpload:false,
      /*图片是否上传了*/
      rulesImage: [{ validator: validatorImages, required: true, message: '请上传房源广告图片', trigger: 'change' }],
      ueditor: {
        config: {
          initialFrameWidth: 400,
          initialFrameHeight: 300
        },
      },
      ueditor2: {
        config: {
          initialFrameWidth: 400,
          initialFrameHeight:200
        },
      },
      ueditor3: {
        config: {
          initialFrameWidth: 400,
          initialFrameHeight:200
        },
      },
      ueditor4: {
        config: {
          initialFrameWidth: 400,
          initialFrameHeight:200
        },
      },
      ue1:"ue1",
      ue2:"ue2",
      ue3:"ue3",
      ue4:"ue4",
      iscategorya:false,
      excludeIds:[],
      isProductUpload:false,
      isVideoUpload: false,
      cindex:0,
      image_index:0,
      is_linkset:false,

    };
  },
  props: ['form','editType'],
  methods: {
       /*选择链接*/
       changeLink(index) {
      this.is_linkset = true;
      this.image_index = index
    },
        /*获取链接并关闭弹窗*/
        closeLinkset(e) {
          this.is_linkset = false
          if (e) {
            this.form.ban[this.image_index].linkUrl = e.url;
            this.form.ban[this.image_index].linkName = "链接到" + " " + e.type + " " + e.name;
            this.form.ban[this.image_index].type = e.type 
          }
    },
    addBan(code=""){
  
  this.form.ban.push({
    file_path:"",
    linkUrl:"",
    linkName:"",
    type:""
  });

},
delBan(index){//删除广告
  this.form.ban.splice(index, 1);
},
   /* 打开视频 */
   openVideoUpload() {
      this.isVideoUpload = true;
    },
    /* 获取视频 */
    returnVideosFunc(e) {
      console.log(e);
      if (e != null && e.length > 0) {
        this.form.video = e[0].file_path;
      }
      this.isVideoUpload = false;
    },


    /*打开上传图片*/
    openProductUpload: function () {
      this.isProductUpload = true;
    },

    /*上传商品图片*/
    returnProductImgsFunc(e) {
      if (e != null) {
        let imgExpt = ["bmp", "jpg", "jpeg", "png", "gif"];
        let prevent = false;
        console.log(typeof imgExpt);
        e.forEach((element) => {
          let data_array = element.file_path.split(".");
          let ext = data_array[data_array.length - 1];
          imgExpt.forEach((e) => {
            if (e === ext) {
              prevent = true
              return false
            }
          });
        });

        if (!prevent) {
          this.$message.error("图片类型有误,请选择正确的图片格式");
          return false;
        }

        let imgs = this.form.imgUrl.concat(e);
        this.$set(this.form, "imgUrl", imgs);
      }
      this.isProductUpload = false;
    },

    /*删除商品图片*/
    deleteImg(index) {
      this.form.imgUrl.splice(index, 1);
    },

    addLabel(code=""){
  
      this.form.label.push({
        index:  this.form.label.length+1,
        name:""
      });
    
    },
    delLabel(e,index){//删除广告
      this.form.label.splice(index, 1);
    },





    del(id){
      var arr = [];
      console.log(id)
      this.form.time_bucket.forEach(function(res){
        if(res.id != id){
          arr.push(res)
        }
      })
      this.form.time_bucket = arr
    },
    add(){
      console.log(this.form)
      this.form.time_bucket.push({
        id:  (Math.floor(Math.random() * 99999) + 1)+"_"+ (Math.floor(Math.random() * 1000) + 1)+"_"+ (Math.floor(Math.random() * 10) + 1),
        start_time:"",
        end_time:"",
      });
      console.log('this.form.time_bucket',this.form.time_bucket);
    },
    chooseCategory(index){
      this.cindex = index;
      this.iscategorya = true;
    },
     /*获取富文本内容*/
    contentChangeFunc(e){
      this.form.content=e;
    },
    contentChangeFuncSubtitle(e){
      this.form.subtitle = e;
    },
    contentChangeFuncRoute(e){
      this.form.route = e;
    },
    contentChangeFuncNotice(e){
      this.form.notice = e;
    },
    /*上传*/
    openUpload(e) {
      this.isupload = true;
    },

    /*获取图片*/
    returnImgsFunc(e) {
      if (e != null && e.length > 0) {
        this.form.imgUrl = e[0].file_path;

      }
      this.isupload = false;
    },
    addCate(code=""){
  
  this.form.categorya.push({
    index:  this.form.categorya.length+1,
    name:""
  });

},
delCate(e,index){//删除广告
  this.form.categorya.splice(index, 1);
},
    closeDialogFunc(e) {
      console.log(e)
      let self = this;
      self.iscategorya = false;
      if (e.type === 'success') {
        self.form.categorya[e.index] = {
            name: e.params[0].name,
            categorya_id: e.params[0].categorya_id,
            image: e.params[0].image,
          }
      }
    },
    selectImage(index){
      this.image_index = index;
      
      this.isAboutLogoUpload = true
    },
        // 上传logo图片
        returnLogoImgsFunc(e) {
      if (e != null) {
        let imgExpt = ['bmp', 'jpg', 'jpeg', 'png', 'gif']
        let prevent = false
        e.forEach((element) => {
          let data_array = element.file_path.split('.')
          let ext = data_array[data_array.length - 1]
          imgExpt.forEach((e) => {
            if (e === ext) {
              prevent = true
              return false
            }
          })
        })
        if (!prevent) {
          this.$message.error('图片类型有误,请选择正确的图片格式')
          return false
        }
        this.form.ban[this.image_index].file_id = e[0].file_id
        this.form.ban[this.image_index].file_path = e[0].file_path
      }
      this.isAboutLogoUpload = false
    },
  

  }
};
</script>

<style lang="scss">
.edit_container {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}

.ql-editor {
  height: 400px;
}


.draggable-list {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  flex-wrap: wrap;
}

.draggable-list .wrapper > span {
  display: flex;
  justify-content: flex-start;
  flex-wrap: wrap;
}

.draggable-list .item {
  position: relative;
  width: 110px;
  height: 110px;
  margin-top: 10px;
  margin-right: 10px;
  border-radius: 8px;
  overflow: hidden;
  border: 1px solid #dddddd;
}

.draggable-list .delete-btn {
  position: absolute;
  top: 0;
  right: 0;
  width: 16px;
  height: 16px;
  background: red;
  line-height: 16px;
  font-size: 16px;
  color: #ffffff;
  display: none;
}

.draggable-list .item:hover .delete-btn {
  display: block;
}

.draggable-list .item img {
  position: absolute;
  top: 50%;
  left: 50%;
  -webkit-transform: translate(-50%, -50%);
  transform: translate(-50%, -50%);
  max-height: 100%;
  max-width: 100%;
}

 .img-select {
  display: flex;
  justify-content: center;
  align-items: center;
  border: 1px dashed #dddddd;
  font-size: 30px;
}

 .img-select i {
  color: #409eff;
}
</style>



// WEBPACK FOOTER //
// src/views/plus/activity/activity/part/Basic.vue